import { render, staticRenderFns } from "./ApprovalHome.vue?vue&type=template&id=f33ddd2e"
import script from "./ApprovalHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApprovalHome.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ApprovalHome.vue?vue&type=style&index=0&id=f33ddd2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports